<template>
  <div :key="key">
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">基本信息</div>
      </div>
    </div>

    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="100px"
      label-position="right"
      :label-suffix="(type == 'preview' ? '：' : '')"
    >
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item
            label="用户名称"
            :prop="type != 'preview' ? 'userName' : ''"
            :class="{'mb-0':type == 'preview'}"
          >
            <el-input v-model="form.userName" placeholder="请输入" v-if="type != 'preview'"></el-input>
            <span v-else>{{ parseStrEmpty(form.userName) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item
            label="联系方式"
            :prop="type != 'preview' ? 'phone' : ''"
            :class="{'mb-0':type == 'preview'}"
          >
            <el-input v-model="form.phone" placeholder="请输入" v-if="type != 'preview'"></el-input>
            <span v-else>{{ parseStrEmpty(form.phone) }}</span>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item
            label="邮箱"
            :prop="type != 'preview' ? 'email' : ''"
            :class="{'mb-0':type == 'preview'}"
          >
            <el-input v-model="form.email" placeholder="请输入" v-if="type != 'preview'"></el-input>
            <span v-else>{{ parseStrEmpty(form.email) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item
            label="所属角色"
            :prop="type != 'preview' ? 'roleIds' : ''"
            :class="{'mb-0':type == 'preview'}"
          >
            <el-select
              v-if="type != 'preview'"
              v-model="form.roleIds"
              collapse-tags
              filterable
              multiple
              placeholder="请选择角色名称"
            >
              <el-option
                v-for="item in roleList"
                :key="item.id"
                :label="item.roleName"
                :value="item.id"
              ></el-option>
            </el-select>
            <span v-else>{{ parseStrEmpty(form.roleNames) }}</span>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24" :xs="12">
          <el-form-item
            label="所属部门"
            :prop="type != 'preview' ? 'deptIds' : ''"
            :class="{'mb-0':type == 'preview'}"
          >
            <TreeTransfer
              v-if="type != 'preview'"
              ref="treeTransfer"
              :filterKey="`deptName`"
              :chooseList="chooseDepts"
              :defaultRxpandAll="true"
              :expandOnClickNode="false"
              :placeholder="`请输入部门名称`"
              :rightTitle="`已选择的部门`"
              @on-tree="handleNodeTree"
              @on-delete="handleNodeDelete"
            ></TreeTransfer>
            <span v-else>{{ parseStrEmpty(form.deptNames) }}</span>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="备注" class="remarkNoLineH">
            <el-input
              v-if="type != 'preview'"
              v-model="form.remark"
              placeholder="请输入"
              maxlength="300"
              type="textarea"
              resize="none"
              rows="3"
            ></el-input>
            <span v-else>{{ form.remark ? form.remark : '-' }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="type == 'preview'" class="form-operation">
        <el-col :span="12">
          <el-form-item label="操作人" class="mb-0">
            <span>{{ parseStrEmpty(form.updateBy) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="操作时间" class="mb-0">
            <span>{{ parseStrEmpty(form.updateTime) }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getRoleList, modifyAccount } from '@/api/system/system'
import { isEmailNull, isPhoneNull } from '@/utils/validate'
import TreeTransfer from '@/views/system/account/components/treeTransfer'
export default {
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  components: {
    TreeTransfer,
  },
  data() {
    return {
      roleList: [],
      chooseDepts: [],
      deptIds: [],
      form: {
        email: '',
        phone: '',
        userName: '',
        deptIds: [],
        roleIds: [],
        remark: '',
      },
      rules: {
        userName: [{ required: true, message: '请输入用户名称', trigger: 'blur' }],
        phone: [{ required: true, validator: isPhoneNull, trigger: 'blur' }],
        // email: [{ required: true, validator: isEmailNull, trigger: 'blur' }],
        roleIds: [{ required: true, message: '请选择角色', trigger: ['blur', 'change'] }],
        deptIds: [{ required: true, message: '请选择部门', trigger: 'blur' }],
      },
    }
  },
  computed: {
    ...mapState({ deptList: (state) => state.system.deptList }),
  },
  created() {
    this.getRoles()
  },
  methods: {
    async getRoles() {
      let result = await getRoleList({
        pageNo: 1,
        pageSize: 30,
        status: 0,
      })
      if (result.code == 200 && result.flag) {
        this.roleList = result.data.items
      } else {
        this.$message.error(result.message)
      }
    },
    formatListToIds(list) {
      let ids = []
      if (list && list.length > 0) {
        list.some((d) => {
          ids.push(d.id)
        })
      }
      return ids
    },
    getDetails(row) {
      if (row) {
        this.form = Object.assign(this.form, row)
        if (this.type == 'update') {
          this.chooseDepts = row.deptRespList
          this.deptIds = this.formatListToIds(row.deptRespList)
          this.form.deptIds = this.formatListToIds(row.deptRespList)
          this.form.roleIds = this.formatListToIds(row.roleRespList)
        }
      }
    },
    submit() {
      return new Promise((resolve, reject) => {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            let result = await modifyAccount(this.form, this.type)
            if (result.code == 200 && result.flag) {
              this.$message.success('提交成功')
              resolve()
            } else {
              this.$message.error(result.message)
              reject()
            }
          } else {
            reject()
          }
        })
      })
    },
    reset() {
      if (this.type != 'preview') this.$refs['treeTransfer'].handleNodesDelete()

      this.form = {
        email: '',
        phone: '',
        userName: '',
        deptIds: [],
        roleIds: [],
        remark: '',
      }
      this.resetForm('form')
    },
    handleNodeTree(data) {
      let isExit = this.chooseDepts.some((item) => item.id === data.id)
      if (isExit) return
      this.chooseDepts.push(data)
      this.form.deptIds = this.chooseDepts.map((item) => item.id)
      console.log(this.form)
      this.resetField('form', 'deptIds')
    },
    handleNodeDelete(data) {
      if (!data) {
        this.chooseDepts = []
        this.form.deptIds = []
      }
      let deptIndex = this.chooseDepts.findIndex((item) => item.id === data.id)
      this.chooseDepts.splice(deptIndex, 1)
      this.form.deptIds = this.chooseDepts.map((item) => item.id)
    },
    cancel() {},
  },
}
</script>

<style scoped lang='less'>
@import '../../../../assets/form.less';
/deep/ .el-input--suffix .el-input__inner {
  width: 363px;
}
::v-deep {
  .no-contract-type {
    padding: 30px;
    background-color: #f8f8f8;
    border-radius: 12px;
    text-align: center;
    border: 1px solid #dde4ff;
    margin-bottom: 20px;
  }
}
</style>